<div class="email-preview">
  <button
    pButton
    type="button"
    size="small"
    class="email-preview__toggle p-button-ai"
    data-cy="email-preview-toggle"
    (click)="toggle()"
  >
    <i
      class="pi"
      [class.pi-eye-slash]="expanded()"
      [class.pi-eye]="!expanded()"
      aria-hidden="true"
    ></i>
    {{ expanded() ? "Hide preview client email" : "Show preview client email" }}
    <i
      class="pi email-preview__toggle-caret"
      [class.pi-chevron-up]="expanded()"
      [class.pi-chevron-down]="!expanded()"
      aria-hidden="true"
    ></i>
  </button>

  @if (expanded()) {
    <div class="email-preview__frame">
      @if (details().getSalesEmail()) {
        <div class="email-preview__row email-preview__row--sender">
          <span class="email-preview__label">Your email:</span>
          <span class="email-preview__value">{{
            details().getSalesEmail()
          }}</span>
        </div>
      }

      <div class="email-preview__panel">
        <div
          class="email-preview__columns"
          [class.email-preview__columns--single]="!details().hasAttachments()"
        >
          <div class="email-preview__message">
            <div class="email-preview__row">
              <span class="email-preview__label">Client email:</span>
              <span class="email-preview__value email-preview__value--strong">
                {{ details().getClientEmail() || "-" }}
              </span>
            </div>

            <div class="email-preview__row">
              <span class="email-preview__label">Subject:</span>
              <span class="email-preview__value email-preview__value--strong">
                {{ details().getClientSubject() || "-" }}
              </span>
            </div>

            @if (body()) {
              <div class="email-preview__body">{{ body() }}</div>
            }
          </div>

          @if (details().hasAttachments()) {
            <app-quote-email-attachments
              class="email-preview__files"
              [quoteId]="quoteId()"
              [attachments]="details().getAttachments()"
              [canDelete]="canDelete()"
            ></app-quote-email-attachments>
          }
        </div>
      </div>
    </div>

    <button
      pButton
      type="button"
      size="small"
      class="email-preview__toggle p-button-ai"
      aria-label="Hide preview client email"
      (click)="toggle()"
    >
      <i class="pi pi-chevron-up" aria-hidden="true"></i>
    </button>
  }
</div>
